<template>
  <div
    v-if="main.companySummary"
    class="company-module"
    data-cy="company-module"
  >
    <RenewModal v-if="showRenewModal" @closeModal="showRenewModal = false" />
    <EmailFormModal
      v-if="showEmailModal"
      :callerType="EmailFormCallerType.DashboardRequest"
      @closeModal="showEmailModal = false"
      open
    />
    <span class="company-module__name" data-cy="company-module-name">{{
      main.companySummary.Name
    }}</span>
    <div class="company-module__container">
      <div>
        <span data-cy="company-module-account-number-label"
          >Account Number:
        </span>
        <span class="info-blue" data-cy="company-module-account-number"
          ><span>{{ main.companySummary.Id }}</span></span
        >
      </div>
      <div>
        <span data-cy="company-module-admin-label">Account Administrator: </span
        ><span
          class="info-blue"
          v-if="
            main.companySummary.MailingName ||
            main.companySummary.WebContactEmail
          "
          data-cy="company-module-admin"
        >
          {{ main.companySummary.MailingName }} /
          {{ main.companySummary.WebContactEmail }}</span
        >
      </div>
      <div>
        <span data-cy="company-module-status-label">Account Status: </span>
        <span data-cy="company-module-status">{{
          main.companySummary.StatusString  }}

          <!--<div @click="showRenewModal = true">-->
          <a class="how-to-renew" data-cy="company-module-renew" @click="showRenewModal = true">   <!--company-module__contact-action -->
          <font-awesome-icon icon="users" />
          How to Renew         
        </a>
      <!--</div> -->
        
      </span>
      </div>

      <a class="company-module__contact-action" data-cy="company-module-renew">        
        <span @click="showEmailModal = true"
          ><font-awesome-icon icon="envelope" /> Got other updates or questions?
          Contact Us.</span
        >
      </a>

      <a
        class="company-module__contact-action"
        data-cy="company-module-contact"
      >
        <p
          v-if="main.companySummary.onWebHold"
          class="company-module__web-hold"
        >
          * Company does not have OUDirect access
        </p>
      </a>

      <div class="company-module__info">
        <div class="pull-left company-module__address">
          <div class="plant-info__bold" data-cy="company-module-address-label">
            Company Address
          </div>
          <div
            v-for="address in main.companySummary.CompanyAddresses"
            :key="address"
            data-cy="company-module-address"
          >
            {{ address }}
          </div>
        </div>
        <div class="pull-left">
          <span class="plant-info__bold" data-cy="company-module-rc-label"
            >Account Executive / Rabbinic Coordinator (RC)</span
          >
          <div data-cy="company-module-rc-name">
            {{ main.companySummary.RcFullName }}
          </div>
          <a
            :href="`mailto:${main.companySummary.RcEmail}`"
            data-cy="company-module-rc-email"
            >{{ main.companySummary.RcEmail }}</a
          >
          <div data-cy="company-module-rc-phone">
            {{ main.companySummary.RcPhone }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMainStore } from "@/stores/useMainStore";
import EmailFormModal from "@/shared/ui/modal/EmailFormModal.vue";
import { ref } from "vue";
import { EmailFormCallerType } from "@/Domain/EmailFormCallerType";
import RenewModal from "./RenewModal.vue";

const main = useMainStore();
const showRenewModal = ref(false);
const showEmailModal = ref(false);
</script>

<style scoped lang="scss">
.company-module {
  color: #666;
  line-height: 1.6;

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &__address {
    width: 200px;
    margin-right: 50px;
  }

  &__name {
    display: block;
    font-weight: bold;
    font-size: 26px;
    margin-bottom: 20px;
    color: #333;
  }

  &__contact-action {
    display: flex;
    margin: 10px 0;
    color: #337ab7;
    cursor: pointer;
    justify-content: space-between;
    flex-wrap: wrap;
    > span:hover {
      text-decoration: underline;
    }
  }

  &__web-hold {
    color: red;
    font-weight: bold;
    cursor: unset;
    margin-top: -5px;
  }

  &__info {
    border-top: 1px solid #ddd;
    padding-top: 10px;
  }

  .info-blue {
    color: #337ab7;
  }

  .how-to-renew {
    padding-left: 15px;
  }
}
</style>
